'use strict';
(function (window) {

	// window.console.log = function(){}
	var comFn = {
		//获取url参数
		getParam: function (name) {
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
			var r = ('?' + (window.location.href).split('?')[1]).substr(1).match(reg);
			if (r != null) return unescape(r[2]);
			return null;
		},
		// 获取url参数
		getQueryString: function(name){
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); // 匹配目标参数
			var result = window.location.search.substr(1).match(reg); // 对querystring匹配目标参数
			if (result != null) {
				return decodeURIComponent(result[2]);
			} else {
				return '';
			}
		},
		//判断运行环境
		userAgent: function () {
			var u = window.navigator.userAgent,
				isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
				isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
				isWeixin = u.toLowerCase().indexOf('micromessenger') > -1,
				isWindows = u.toLowerCase().indexOf('windows') > -1
			var result = {
				"isIOS": isIOS,
				"isAndroid": isAndroid,
				"isWindows": isWindows,
				"isWeixin": isWeixin
			}
			return result;
		},
		// 判断是否是PC
		isPC: function () {
			var userAgentInfo = navigator.userAgent;
			var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod", "iPad"];
			var flag = true;
			console.log(userAgentInfo)
			for (var i = 0; i < Agents.length; i++) {
				if (userAgentInfo.indexOf(Agents[i]) > 0) {
					flag = false;
					break;
				}
			}
			return flag;
		},
		//获取地理位置
		getLocation: function (success, fail) {
			comFn.showLoading();
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(function (position) {
					if (position.coords) {
						comFn.hideLoading();
						if (success) {
							success(position.coords.longitude, position.coords.latitude);
						}
					} else {
						comFn.hideLoading();
						comFn.showToast('定位出错');
						setTimeout(function () {
							if (fail) {
								fail();
							}
						}, 1000);
					}
				}, function (error) {
					var msg = '未知错误';
					switch (error.code) {
						case 1:
							msg = '定位被拒绝';
							break;
						case 2:
							msg = '定位失败';
							break;
						case 3:
							msg = '定位超时';
							break;
					}
					comFn.hideLoading();
					comFn.showToast(msg);
					setTimeout(function () {
						if (fail) {
							fail();
						}
					}, 1000);
				});
			} else {
				comFn.hideLoading();
				comFn.showToast('当前设备不支持定位');
				setTimeout(function () {
					if (fail) {
						fail();
					}
				}, 1000);
			}
		},
		//去除字符串两端空格
		trimStr: function (str) {
			return str.replace(/(^\s*)|(\s*$)/g, "");
		},
		//开启滚动条监听，滚动到底后执行回调
		onSlide: function (callback) {
			var that = this;
			$(window).on('scroll', function () {
				if (document.body.scrollHeight - window.scrollY <= (window.innerHeight + 20)) {
					that.offSlide();
					callback();
				}
			});
		},
		//关闭滚动条监听
		offSlide: function () {
			$(window).off('scroll');
		},
		strim: function (str) {
			if (str === undefined || str === null) return '';
			return str.replace(/(^\s*)|(\s*$)/g, '');
		},
		//ajax
		ajax: function (params) {
			// var csrftoken = '';
			// var _this = this;
			// try {
			// 	csrftoken = document.cookie.split('csrfToken=')[1].split(';')[0];
			// } catch (e) { }
			// if (!csrftoken) {
			// 	$.ajax({
			// 		type: 'get',
			// 		url: '/',
			// 		data: {},
			// 		complete: function () {
			// 			_this.ajax(params)
			// 		}
			// 	});
			// 	return
			// }
			// function csrfSafeMethod(method) {
			// 	return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
			// }
			var _data = {};
			if (params.data) {
				params.data.lang = localStorage.lang || 'en';
				for (var key in params.data) {
					if (typeof (params.data[key]) === 'string') {
						params.data[key] = this.strim(params.data[key])
					}
				}
				_data = params.data;

			} else {
				_data = {
					lang: localStorage.lang || 'en'
				}
			}
			$.ajax({
				type: 'post',
				url: '' + params.url,
				data: _data,
				beforeSend: function (xhr, settings) {
					// if (!csrfSafeMethod(settings.type)) {
					// 	xhr.setRequestHeader('x-csrf-token', csrftoken);
					// }
					if (params.beforeSend) {
						params.beforeSend();
					}
				},
				success: function (res) {
					params.success(res);
				},
				error: function (err) {
					if (err.status == 302) {
						if (params.self) {
							params.self.msg('用户未登陆11');
						}
						// setTimeout(function () {
						// 	if (params.self) {
						// 		var backUrl = (window.location.pathname || '') + window.location.search || ''
						// 		if (parent.window.toURL) {
						// 			if (window.location.pathname) {
						// 				if (backUrl.indexOf('/official/') > -1) {
						// 					parent.window.toURL('/page/account/login.html?backUrl=' + backUrl)
						// 				} else {
						// 					parent.window.toURL('/page/account/login.html')
						// 				}
						// 			} else {
						// 				parent.window.toURL('/page/account/login.html')
						// 			}
						// 		} else {
						// 			window.location.replace('/page/account/login.html')
						// 		}
						// 	}
						// }, 1000);
					} else {
            params.self && params.self.msg('网络错误！稍后重试');

						//			params.error && params.error(err);
					}
					params.error && params.error(err);
				},
				complete: function (res) {
					params.complete && params.complete(res);
				}
			});
		},
		paramToObject: function (str) {
			var obj = {};
			if (str.substring(0, 1) == '?') {
				str = str.slice(1);
			}

			var strArr = str.split('&');
			var param = '';
			for (var i = 0; i < strArr.length; i++) {
				param = strArr[i].split('=');
				obj[param[0]] = decodeURIComponent(param[1]) || null;
			}
			return obj;
		},
		paramToStr: function (obj) {
			var str = '?';
			for (var key in obj) {
				str += key + "=" + obj[key] + '&';
			}
			return str;
		},
		//upload
	}
	window.comFn = comFn;
})(window)



// WEBPACK FOOTER //
// ./src/assets/js/common.js